export default {
  SET_RESULTS(state, result) {
    const resultsCopy = { ...state.results };
    resultsCopy[result.endpoint] = result.response;

    state.results = resultsCopy;
  },
  UPDATE_EDIT_QUERY(state, query) {
    const queryCopy = state.editQuery;
    queryCopy[query.endpoint] = query.payload;

    state.editQuery = JSON.parse(JSON.stringify(queryCopy));
  },
};
